// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconMedStereo_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s16IconSvg = html `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M8 12.9003C7.24993 13.2837 6.40022 13.5 5.5 13.5C2.46243 13.5 0 11.0376 0 8C0 4.96243 2.46243 2.5 5.5 2.5C6.40022 2.5 7.24993 2.71628 8 3.09971C8.75007 2.71628 9.59978 2.5 10.5 2.5C13.5376 2.5 16 4.96243 16 8C16 11.0376 13.5376 13.5 10.5 13.5C9.59978 13.5 8.75007 13.2837 8 12.9003ZM6.20026 11.4299C5.974 11.4759 5.73982 11.5 5.5 11.5C3.567 11.5 2 9.933 2 8C2 6.067 3.567 4.5 5.5 4.5C5.73982 4.5 5.974 4.52412 6.20025 4.57006C5.44908 5.5105 5 6.7028 5 8C5 9.29719 5.44908 10.4895 6.20026 11.4299ZM9.79975 4.57007C10.026 4.52412 10.2602 4.5 10.5 4.5C12.433 4.5 14 6.067 14 8C14 9.933 12.433 11.5 10.5 11.5C10.2602 11.5 10.026 11.4759 9.79975 11.4299C10.5509 10.4895 11 9.29719 11 8C11 6.70281 10.5509 5.5105 9.79975 4.57007ZM8 5.55051C8.6186 6.18178 9 7.04635 9 8C9 8.95365 8.6186 9.81822 8 10.4495C7.38141 9.81822 7 8.95365 7 8C7 7.04635 7.38141 6.18178 8 5.55051Z" class="svg-bg"/>
</svg>
`;
/**
 * IconMedStereo is a generated icon component.
 */
let IconMedStereo = IconMedStereo_1 = class IconMedStereo extends IconBaseElement {
    render() {
        return html `${IconMedStereo_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconMedStereo.icons = new Map([
    ['s8', _s16IconSvg],
    ['s12', _s16IconSvg],
    ['s16', _s16IconSvg],
    ['s24', _s16IconSvg],
    ['s32', _s16IconSvg],
    ['s40', _s16IconSvg],
    ['s48', _s16IconSvg],
    ['s64', _s16IconSvg],
    ['s72', _s16IconSvg],
    ['s80', _s16IconSvg],
]);
IconMedStereo = IconMedStereo_1 = __decorate([
    customElement('zui-icon-med-stereo')
], IconMedStereo);
export { IconMedStereo };
